import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImageOne from "@/components/uploadImage";
import uploadImageTow from "@/components/uploadImage";
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor,
    uploadImageOne: uploadImageOne,
    uploadImageTow: uploadImageTow
  },
  props: {
    gameLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isOnlyWatch: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      form: {
        appid: '',
        server_name: '',
        recharge_desc: '',
        login_callback: '',
        pay_callback: '',
        show_name: '',
        banner: '',
        bannerMb: '',
        product_check_link: '',
        params: [],
        extend: [],
        state: '',
        pay_type_list: [],
        pay_type_icon: '',
        delay_time: ''
      },
      formMark: {},
      paramsMark: {
        language: '',
        languageName: '',
        area: '',
        game_area_name: '',
        game_area_desc: '',
        server_name: '',
        page_title: '',
        note: '',
        banner: '',
        bannerMb: '',
        picfileList: [],
        picfileListMb: [],
        extend: [],
        recharge_desc: ''
      },
      stateList: [{
        label: '启用',
        value: 2
      }, {
        label: '禁用',
        value: 1
      }, {
        label: '敬请期待',
        value: 3
      }],
      copyform: {},
      picfileList: [],
      picfileListMb: [],
      dialogShow: false,
      rules: {
        show_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }],
        appid: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        server_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        recharge_desc: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        area: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        game_area_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        game_area_desc: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        banner: [{
          required: true,
          message: "请上传",
          trigger: "blur"
        }],
        bannerMb: [{
          required: true,
          message: "请上传",
          trigger: "blur"
        }],
        page_title: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        extend: [{
          required: true,
          message: "请添加参数",
          trigger: "blur"
        }],
        pay_type_list: [{
          required: true,
          message: "请添加支付类型参数",
          trigger: "blur"
        }],
        pay_type: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        pay_type_icon: [{
          required: true,
          message: "请上传",
          trigger: "blur"
        }],
        pay_type_id: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        pay_type_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        delay_time: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }] // product_check_link: [{ required: true, message: "请输入", trigger: "blur" }],
        // login_callback: [{ required: true, message: "请输入", trigger: "blur" }],
        // pay_callback: [{ required: true, message: "请选择", trigger: "blur" }],

      },
      languageList: [],
      dingshiList: [{
        label: '否',
        value: 1
      }, {
        label: '是',
        value: 2
      }],
      dingshi: 1
    };
  },
  created: function created() {
    this.copyform = _objectSpread({}, this.form);
    this.formMark = JSON.parse(JSON.stringify(this.form));
    this.getlangList();
  },
  methods: {
    changTime: function changTime(val) {
      if (val == 1) {
        this.form.delay_time = '';
      }
    },
    init: function init(datas, type) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, lang, list, extendList, extend, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                if (type) {
                  _this.dingshi = 2;
                } else {
                  _this.dingshi = 1;
                }

                if (datas) {
                  data = JSON.parse(JSON.stringify(datas));
                  console.log("data==", data);
                  lang = data.language ? data.language.split(',') : [];
                  list = [];
                  lang.forEach(function (i) {
                    list.push(data.params.findIndex(function (j) {
                      return j.language == i;
                    }) > -1 ? data.params.find(function (j) {
                      return j.language == i;
                    }) : _objectSpread(_objectSpread({}, _this.paramsMark), {}, {
                      language: i,
                      languageName: _this.languageList.find(function (j) {
                        return j.sign == i;
                      }).name
                    }));
                  });
                  console.log(list);
                  list.map(function (i) {
                    i.picfileList = i.banner ? [i.banner] : '', i.picfileListMb = i.bannerMb ? [i.bannerMb] : '', i.bannerMb = i.bannerMb ? i.bannerMb : '';
                    i.recharge_desc = _this.$utils.textRepl(i.recharge_desc);
                  });
                  extendList = JSON.parse(data.extend);
                  extend = [];

                  for (key in extendList) {
                    extend.push({
                      label: key,
                      value: extendList[key]
                    });
                  }

                  data.extend = extend;
                  data.params = list; //支付类型

                  data.pay_type_list = data.pay_type_list || [];
                  data.pay_type_list.map(function (i) {
                    i.picfileList = i.pay_type_icon ? [i.pay_type_icon] : '';
                  });

                  if (data.delay_time) {
                    _this.dingshi = 2;
                  }

                  _this.form = _objectSpread({}, data);

                  _this.$nextTick(function () {
                    var dialogs_body = document.getElementsByClassName("dialogs_body");
                    dialogs_body.forEach(function (item) {
                      item.scrollTop = 0;
                    });
                  });
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getlangList: function getlangList() {
      var _this2 = this;

      this.$api.languageInfoData().then(function (res) {
        if (res.code == 0) {
          _this2.languageList = res.data;
        }
      });
    },
    addContent: function addContent() {
      this.form.extend.push({
        label: "",
        value: ""
      });
    },
    addPayTypeList: function addPayTypeList() {
      this.form.pay_type_list.push({
        pay_type: "",
        pay_type_icon: "",
        pay_type_id: "",
        pay_type_name: ""
      });
    },
    removeContent: function removeContent(item) {
      var index = this.form.extend.indexOf(item);

      if (index !== -1) {
        this.form.extend.splice(index, 1);
      }
    },
    removePayTypeList: function removePayTypeList(item) {
      var index = this.form.pay_type_list.indexOf(item);

      if (index !== -1) {
        this.form.pay_type_list.splice(index, 1);
      }
    },
    payTypeImgChange: function payTypeImgChange(e, item, index) {
      this.form.pay_type_list[index].picfileList = e;
      this.form.pay_type_list[index].pay_type_icon = e[0] && e[0].response ? e[0].response.data : '';
    },
    gameChange: function gameChange(e) {
      var _this3 = this;

      var data = this.gameLists.find(function (i) {
        return i.appid == _this3.form.appid;
      });
      var lang = data.language ? data.language.split(',') : [];
      var list = [];
      lang.forEach(function (i) {
        list.push(JSON.parse(JSON.stringify(_objectSpread(_objectSpread({}, _this3.paramsMark), {}, {
          language: i,
          languageName: _this3.languageList.find(function (j) {
            return j.sign == i;
          }).name
        }))));
      });
      this.form.params = list;
      this.$nextTick(function () {
        var dialogs_body = document.getElementsByClassName("dialogs_body");
        dialogs_body.forEach(function (item) {
          item.scrollTop = 0;
        });
      });
    },
    imgChange: function imgChange(e, item, index, type) {
      this.form.params[index][type ? 'picfileListMb' : 'picfileList'] = e;
      this.form.params[index]['banner' + type] = e[0] && e[0].response ? e[0].response.data : '';
      console.log(this.form.params);
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = _objectSpread(_objectSpread({}, this.copyform), {}, {
        id: type ? this.form.id : ""
      });
      this.form.extend = [];
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this4 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this4.form));
          data.params.map(function (i) {
            i.recharge_desc = i.recharge_desc.replaceAll(_this4.$imgUrl, '');
            i.picfileList = i.picfileList.map(function (j) {
              return j.response ? j.response.data : j.url;
            });
            i.picfileListMb = i.picfileListMb.map(function (j) {
              return j.response ? j.response.data : j.url;
            });
          });
          data.params = JSON.stringify(data.params);
          var d = {};
          data.extend.forEach(function (item, index) {
            d[item.label] = item.value;
          });
          data.extend = JSON.stringify(d);
          data.pay_type_list.map(function (i) {
            i.picfileList = i.picfileList.map(function (j) {
              return j.response ? j.response.data : j.url;
            });
          });
          data.pay_type_list = JSON.stringify(data.pay_type_list);
          var reqFn = data.id ? 'paymentGamesServersUpdate' : 'paymentGamesServersAdd';

          _this4.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this4.$message.success(res.msg);

              _this4.dialogShow = false;

              _this4.$emit('change');
            }
          });
        }
      });
    }
  }
};